import React, { Component, Fragment } from 'react';
import { Prompt } from 'react-router-dom';
import ModalComponent from '../../components/Modal';
import {connect} from 'react-redux';

export class RouteLeavingGuard extends Component {
  state = {
    modalVisible: false,
    lastLocation: null,
    confirmedNavigation: false,
  }

  closeModal = (callback) => this.setState({
    modalVisible: false
  }, () => callback())

  handleBlockedNavigation = (nextLocation) => {
    const { confirmedNavigation } = this.state;
    const { shouldBlockNavigation } = this.props;
    if (shouldBlockNavigation) {

      this.setState({
        modalVisible: true,
        lastLocation: nextLocation,
      });
      return false;
    }

    return true;
  }

  handleConfirmNavigationClick = (cb) => this.closeModal(() => {
    const { lastLocation } = this.state;

    if (lastLocation) { 
      if(cb) {
        cb();
      } else {
        this.props.navigate(lastLocation.pathname);
      }
    }
  });

  handleClose = () => {
    this.setState({
      modalVisible: false,
    })
  }

  render() {
    const { when, approvable,  } = this.props;
    const { modalVisible, lastLocation }  = this.state;
    return (
      <Fragment>
        <Prompt
          when={when}
          message={this.handleBlockedNavigation} />
          {modalVisible &&
          <ModalComponent
              headerTitle="Save changes"
              visibleImg={modalVisible}
              modalBody="Would you like to save your changes?"
              approvable
              onConfirm={this.handleConfirmNavigationClick}
              handleClose={this.handleClose}
              saveChanges={(event) => this.props.saveChanges(event, lastLocation)}
          />}
      </Fragment>
    )
  }
}
const mapStateToProps = (state) => ({
  caseDetails: state.caseDetails,
})
export default connect(mapStateToProps)(RouteLeavingGuard)


// WEBPACK FOOTER //
// ./src/components/RouteLeavingGuard/index.js